export const formatDegrees = (degressFloat: number) => {
    const degrees = Math.floor(Math.abs(degressFloat));
    const degreessFractionalPart = Math.abs(degressFloat) - degrees;
    const minutesFloat = degreessFractionalPart * 60;
    const minutes = Math.floor(minutesFloat);
    const minutesFractionalPart = minutesFloat - minutes;
    const seconds = Math.round(minutesFractionalPart * 60);

    const sign = degressFloat < 0 ? '-' : '';
    let output = `${sign}${degrees.toString()}°`;

    if (minutes !== 0) {
        output += ` ${minutes}′`;
    }

    if (seconds !== 0) {
        output += ` ${seconds}′′`;
    }

    return output;
};
